<template>
    <div class="empty-wrapper">
        <div class="empty-inner" :class="[emptydata.theme]">
            <!-- 网络异常 -->
            <div class="no-network" v-if="emptydata.type === 'failed'">
                <div class="img">
                    <img v-if="emptydata.theme === 'blue'" src="../assets/img/network_blue.png" alt="">
                    <img v-else src="../assets/img/network.png" alt="">
                </div>
                <span>{{$tc('default.connection')}}</span>
            </div>
            <!-- 加载失败 -->
            <div class="loading-fail" v-else-if="emptydata.type === 'nonetwork'">
                <div class="img">
                    <img v-if="emptydata.theme === 'blue'" src="../assets/img/fail_blue.png" alt="">
                    <img v-else src="../assets/img/fail.png" alt="">
                </div>
                <span>{{$tc('default.failed')}}</span>
            </div>
            <!-- 其他情况 -->
            <div class="no-data" v-else>
                <div class="img">
                    <img v-if="emptydata.theme === 'blue'" src="../assets/img/empty_blue.png" alt="">
                    <img v-else src="../assets/img/empty.png" alt="">
                </div>
                <span>{{$tc('default.empty')}}</span>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'Empty',
    props: ['emptydata']
}

</script>

<style lang="scss">
    .empty-wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 5vw 0 2vw;
        .empty-inner {
            text-align: center;
            .img {
                width: 30vw;
                display: inline-block;
            }
            span {
                display: block;
                font-size: 4.259vw;
                color: #B3B3B3;
                line-height: 1.4;
            }
            &.blue {
                span {
                    color: #8389BB;
                }
            }
        }
    }
</style>
